module.exports = __webpack_public_path__ + "img/nhl21.69728297.png";